import {
  CheckRounded,
  PauseRounded,
  PlayArrowRounded,
} from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';

import {
  playerSessionsSelectors,
  playerThunks,
  selectIsEpisodePlaying,
  useAppDispatch,
  useAppSelector,
} from '@/store';
import { Referrer } from '@/types';

import { CAROUSEL_ITEM_WIDTH } from './constants';

export const EpisodeStatusButton = ({
  episodeId,
  showProgressLine = true,
  referrer,
}: {
  episodeId: string;
  showProgressLine?: boolean;
  referrer: Referrer;
}) => {
  const dispatch = useAppDispatch();

  const isEpisodePlaying = useAppSelector(state =>
    selectIsEpisodePlaying(state, episodeId),
  );
  const playerSession = useAppSelector(state =>
    playerSessionsSelectors.selectById(state, episodeId),
  );

  const onButtonClick = () => {
    dispatch(
      playerThunks.episodePlayPressed({
        episodeId,
        location: referrer,
        referrer,
      }),
    );
  };

  const status = playerSession?.status;
  const isEpisodeCompleted = status === 'verified' || status === 'completed';
  const Icon = isEpisodeCompleted
    ? CheckRounded
    : isEpisodePlaying
      ? PauseRounded
      : PlayArrowRounded;
  return (
    <Box
      sx={{
        mt: 1.5,
        position: 'relative',
      }}>
      <IconButton
        onClick={onButtonClick}
        aria-label={isEpisodePlaying ? 'pause episode' : 'play episode'}
        sx={[
          {
            width: 42,
            height: 42,
            p: 0.5,
            bgcolor: isEpisodeCompleted ? 'secondary.main' : 'surface.base',
            '&:hover': {
              bgcolor: 'secondary.main',
              '> *': {
                color: 'white',
              },
            },
            boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.35)',
            zIndex: 2,
          },
        ]}>
        <Icon
          sx={{
            color: isEpisodeCompleted ? 'white' : 'secondary.main',
            width: '100%',
            height: '100%',
          }}
        />
      </IconButton>
      {showProgressLine && (
        <Box
          sx={{
            height: 4,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translateY(-50%)',
            backgroundColor: 'secondary.main',
            width: CAROUSEL_ITEM_WIDTH,
            zIndex: 1,
          }}
        />
      )}
    </Box>
  );
};
